import spas from 'utils/general/spas'

export const getCurrentInstance = (url: string) => {
  const token = url.split('.')[0]
  return token
    .replace(/^https:\/\/|http:\/\//, '')
    .replace(/-access-dev$/, '')
    .replace(/-access-qa$/, '')
    .replace(/-access-uat$/, '')
    .replace(/-access$/, '')
}

export const createSpaLink = (
  appDomain: string,
  subdomain: {
    suffix: string
    prefix?: string
  },
  instanceName: string,
  path?: string
) => {
  const APP_ENV = process.env.REACT_APP_APP_ENV

  const protocol = 'https://'
  const prefix = subdomain.prefix ?? ''
  const subdomainSuffix = subdomain.suffix ?? ''
  const envSuffix = ['prd', 'production'].includes(APP_ENV as string) ? '' : `-${APP_ENV}`
  const domain = appDomain ?? 'ordernext.com'
  const appPath = path ?? ''

  return `${protocol}${prefix}${instanceName}${subdomainSuffix}${envSuffix}.${domain}/${appPath}`
}

export const createLegacyCanopyLink = (path = '') => {
  const ORG = process.env.REACT_APP_ORG
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const ECOSYSTEM = process.env.REACT_APP_ECOSYSTEM

  return `https://canopy.${APP_ENV}.${ECOSYSTEM}.vnops.net/${path}?url_organization_name=${ORG}`
}

export const getMenuManagerPosAccountsLink = () => {
  const menu = spas?.find((spa) => spa.name === 'menus')

  if (!menu) return ''

  const { domain, subdomain } = menu
  const instance = getCurrentInstance(window.location.href)
  const path = 'pos-accounts'

  return `${createSpaLink(domain, subdomain, instance, path)}`
}
